<template>
        <!-- Form container -->
      <div class="theme-bg-white d-flex col-lg-4 align-items-center p-5">
        <!-- Inner container -->
        <!-- Have to add `.d-flex` to control width via `.col-*` classes -->
        <div class="d-flex col-sm-7 col-md-5 col-lg-12 px-0 px-xl-4 mx-auto">
          <div class="w-100">

            <!-- Logo -->
            <div class="d-flex justify-content-center align-items-center">
              <div class="ui-w-60">
                <div class="w-100 position-relative" style="padding-bottom: 54%">
                  <svg class="w-100 h-100 position-absolute" viewBox="0 0 148 80" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient id="a" x1="46.49" x2="62.46" y1="53.39" y2="48.2" gradientUnits="userSpaceOnUse"><stop stop-opacity=".25" offset="0"></stop><stop stop-opacity=".1" offset=".3"></stop><stop stop-opacity="0" offset=".9"></stop></linearGradient><linearGradient id="e" x1="76.9" x2="92.64" y1="26.38" y2="31.49" xlink:href="#a"></linearGradient><linearGradient id="d" x1="107.12" x2="122.74" y1="53.41" y2="48.33" xlink:href="#a"></linearGradient></defs><path class="fill-primary" transform="translate(-.1)" d="M121.36,0,104.42,45.08,88.71,3.28A5.09,5.09,0,0,0,83.93,0H64.27A5.09,5.09,0,0,0,59.5,3.28L43.79,45.08,26.85,0H.1L29.43,76.74A5.09,5.09,0,0,0,34.19,80H53.39a5.09,5.09,0,0,0,4.77-3.26L74.1,35l16,41.74A5.09,5.09,0,0,0,94.82,80h18.95a5.09,5.09,0,0,0,4.76-3.24L148.1,0Z"></path><path transform="translate(-.1)" d="M52.19,22.73l-8.4,22.35L56.51,78.94a5,5,0,0,0,1.64-2.19l7.34-19.2Z" fill="url(#a)"></path><path transform="translate(-.1)" d="M95.73,22l-7-18.69a5,5,0,0,0-1.64-2.21L74.1,35l8.33,21.79Z" fill="url(#e)"></path><path transform="translate(-.1)" d="M112.73,23l-8.31,22.12,12.66,33.7a5,5,0,0,0,1.45-2l7.3-18.93Z" fill="url(#d)"></path></svg>
                </div>
              </div>
            </div>
            <!-- / Logo -->

            <h4 class="text-center font-weight-normal mt-5 mb-0 e-nusx-8">რეგისტრაციის ფორმა</h4>

            <!-- Form -->
            <form class="my-5" autocomplete="off" aria-autocomplete="off">
              <b-form-group label="თქვენი სახელი და გვარი" class="e-nusx-8">
                <b-input v-model="credentials.name" />
              </b-form-group>
              <b-form-group label="საკონტაქტო ტელეფონის ნომერი" class="e-nusx-8">
                <b-input v-model="credentials.email" class="e-eng-font" autocomplete="off"/>
              </b-form-group>
              <b-form-group label="საკონტაქტო ელ-ფოსტა" class="e-nusx-8">
                <b-input type="password" v-model="credentials.password" />
              </b-form-group>
              <b-btn variant="primary" :block="true" class="mt-4 e-mtavr-17">რეგისტრაცია</b-btn>
              <div class="text-light small mt-4 e-nusx-8 text-justify">
               რეგისტრაციის ღილაკზე დაჭერით თქვენ ეთანხმებით ჩვენს
                <a href="javascript:void(0)" class="e-mtavr-17">უსაფრთხოებისა და სისტემით სარგებლობის პოლიტიკას</a>. ასევე ჩვენი მხრიდან მოგივათ დამათებითი შეტყობინებები სხვადასხვა საკომუნიკაციო არხებში.
              </div>
            </form>
            <!-- / Form -->

            <div class="text-center e-nusx-8">
              უკვე გაქვთ წვდომა? <router-link href="javascript:void(0)" to="/" class="e-mtavr-17">ვტორიზაცია</router-link>
            </div>

          </div>
        </div>
      </div>
      <!-- / Form container -->
</template>

<script>
export default {
  name: 'pages-authentication-login-v3',
  metaInfo: {
    title: 'Login v3 - Pages'
  },
  data: () => ({
    credentials: {
      email: '',
      password: '',
      rememberMe: false
    }
  })
}
</script>
